import React from 'react';
import { ErrorOverlay } from '../ErrorOverlay';
import { ShimmerLoader } from '../ShimmerLoader';
import { Stack } from '../Stack';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingOverlay = _ref => {
  let {
    isLoading,
    isError,
    errorMessage = 'The data did not load properly',
    children
  } = _ref;
  return /*#__PURE__*/_jsx(ShimmerLoader, {
    isLoading: isLoading,
    wrapperStyleProps: {
      root: {
        width: '100%'
      }
    },
    children: /*#__PURE__*/_jsx(ErrorOverlay, {
      isHidden: !isError,
      content: () => /*#__PURE__*/_jsx(Stack, {
        styles: {
          root: {
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            height: '100%',
            textAlign: 'center'
          }
        },
        children: errorMessage
      }),
      children: children
    })
  });
};